<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <FormTable ref="formTable" :formData="formData" :optionConfig="optionConfig" />
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()" :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
    <SelectPlan ref="selectPlan" @replace="replace"></SelectPlan>
  </div>
</template>

<script>
import { add, update, getDetail } from "../api";
import { disposeDetail, showItem, rulesInput } from '@/basic-common/util/common.js';
import SelectPlan from '@/views/railway-management/arrivalnoteplan/components/select-plan.vue';

export default {
  components: { SelectPlan },
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      formData: {
        list: []
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        column: [
          {
            label: '计划名称',
            prop: 'planName',
            // search: true, // 查询是否显示
            overHidden: true,
            allowCreate: true,
            maxlength: 30,
            readonly: true,
            rules: rulesInput(2),
            click: () => {
              this.$refs.selectPlan.open()
            },
          },
          {
            label: "货主",
            prop: "custNo",
            type: "select",
            remote: true,
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            rules: rulesInput(2),
            props: {
              label: "deptName",
              value: "id",
            },
          },
          {
            label: "车次编号",
            prop: "trainNumber",
            rules: rulesInput(1),
          },
          {
            label: "车厢数",
            prop: "carriageCount",
            type: "number",
            min: 1,
            max: 99999,
            rules: rulesInput(1),
          },
          {
            label: "总重量(吨)",
            prop: "totalWeight",
            type: "number",
            precision: 2,
            min: 0.01,
            max: 99999,
            // rules: rulesInput(1),
            display: showItem(
              { add: false, edit: false, view: true },
              this.transmitData.type
            ),
          },
          {
            label: "合同名称",
            prop: "contractName",
            type: "select",
            remote: true,
            dicUrl:
              "/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}",
            props: {
              label: "contractName",
              value: "id",
            },
          },
          {
            label: "到达时间",
            prop: "trainArrivalTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rules: rulesInput(1),
          },
          {
            label: "发车时间",
            prop: "trainDepartTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rules: rulesInput(1),
          },
        ]
      },
      list: [],
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: true,
        align: 'center',
        column: [{
          label: '车厢号',
          prop: 'carriageNumber',
          required: true,
        },
        {
          label: '车厢序号',
          prop: 'carriageSerial',
          type: 'number',
          min: 0,
          max: 99999,
        },
        {
          label: '车型',
          prop: 'carriageType',
        },
        {
          label: '重量(吨)',
          prop: 'totalWeight',
          type: 'custom-input',
          precision: 2,
          required: true,
        },
        // {
        //   label: '称重方式',
        //   prop: 'weightType',
        //   type: 'select',
        //   commonDict: 'weightType',
        //   props: {
        //     label: "dictValue",
        //     value: "dictKey",
        //   },
        //   cell: true
        // },
        // {
        //   label: '皮重(吨)',
        //   prop: 'grossWeight',
        //   type: 'custom-input',
        //   precision: 2,
        //   required: true,
        // }, {
        //   label: '毛重(吨)',
        //   prop: 'tareWeight',
        //   type: 'custom-input',
        //   precision: 2,
        //   required: true,
        // }, {
        //   label: '净重',
        //   prop: 'netWeight',
        //   type: 'custom-input',
        //   precision: 2,
        //   required: true,
        // }
    ]
      }
    }
  },
  created () {
    const { type, id } = this.transmitData
    type !== 'add' && this.getDetail(id)
  },
  methods: {
    //提交
    async submitForm () {
      const list = this.formData.list
      const { type } = this.transmitData
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate) {
          if (type == 'add') {
            add(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
              done()
            })
          } else {
            update(this.formData).then(({ data }) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail (id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
        this.isDetails() && disposeDetail(topTier, 'table-details')
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails () {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    replace (row) {
      const replaceKey = ['planNo', 'planName', 'custNo', 'trainNumber', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    }
  }
}
</script>
<style scoped lang="scss"></style>
